var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"echarts",style:(_vm.size),attrs:{"id":"echart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }